/*
 *
 * ----------------------------------------------- */
import "jquery-modal";

jQuery(window).on("load", function () {
  $("a[data-modal]").click(function () {
    $(this).modal();
    return false;
  });
});
